<template>
  <p class="text-xs-center" v-if="error">Podany link aktywacyjny nie istnieje.</p>
  <v-container v-else fluid fill-height>
    <v-layout align-start justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Aktywacja konta</v-toolbar-title>
          </v-toolbar>
          <form class="login" @submit.prevent="confirmRunner" novalidate>
            <v-card-text>
            <Fields
              v-bind="{fields, object: formData, errors: formErrors}"
            >
              <template slot="fieldTos" slot-scope="{error, errorMessages, field}">
                <v-checkbox
                    :key="field.id"
                    v-bind="field.props"
                    v-model="formData.tos"
                    @input="delete errors[field.id]"
                    @change="delete errors[field.id]"
                    :error="error"
                    :error-messages="errorMessages"
                  >
                  <div slot="label">
                    Akceptuję
                    <v-tooltip bottom>
                      <a slot="activator" target="_blank" href="http://inzynieriabiegania.pl/regulamin" @click.stop>regulamin</a>
                      Otwórz w nowym oknie
                    </v-tooltip>
                    *
                  </div>
                </v-checkbox>
              </template>
            </Fields>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn type="submit" color="primary">Aktywuj konto</v-btn>
            </v-card-actions>
          </form>
          <v-progress-linear v-if="progress" :indeterminate="true"></v-progress-linear>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {accountRunnerAdminConfirmEmail} from './api'
import iziToast from 'izitoast'
import * as types from '@/store/mutation-types'
import Fields from '@/forms/Fields'

export default {
  components: {Fields},
  validators: {
  },
  data () {
    return {
      progress: false,
      formErrors: {},
      formData: {
        key: this.$route.params.token
      },
      error: false
    }
  },
  computed: {
    token () {
      return this.$route.params.token
    },
    fields () {
      return [
        {comp: 'text', id: 'password1', label: 'Hasło', props: {type: 'password', prependIcon: 'lock'}},
        {comp: 'text', id: 'password2', label: 'Powtórz hasło', props: {type: 'password', prependIcon: 'lock'}},
        {comp: 'checkbox', id: 'tos', label: 'Akceptuję regulamin', props: {}},
        {comp: 'checkbox', id: 'personal_data', label: 'Wyrażam zgodę na przetwarzanie moich danych osobowych w celu realizacji zamówionych przeze mnie usług.*', props: {}},
        {comp: 'checkbox', id: 'health_statement', label: 'Oświadczam, że nie mam przeciwwskazań zdrowotnych do udziału w treningu i mój obecny stan zdrowia pozwala na realizowanie planów treningowych oraz że przystępuję do jego realizacji dobrowolnie i na własną odpowiedzialność. Jednocześnie przyjmuję do świadomości, że trening biegowy wiąże się z wysiłkiem fizycznym i biorę pełną odpowiedzialność za kontuzje z niego wynikające.*', props: {}},
        {comp: 'checkbox', id: 'newsletter', label: 'Chcę otrzymywać newsletter. Zezwalam na przetwarzanie moich danych osobowych w celu przysyłania mi informacji marketingowych', props: {}}
      ]
    }
  },
  methods: {
    confirmRunner () {
      this.$validate().then(success => {
        if (success) {
          this.progress = true
          accountRunnerAdminConfirmEmail(this.formData).then((data) => {
            iziToast.show({
              message: 'Konto zostało aktywowane',
              color: 'green'
            })
            this.$store.dispatch(types.AUTH_TOKEN, data.token).then(() => {
              this.$router.push({name: 'app'})
            })
            return data
          }).catch((data) => {
            if (data.response.status === 404) {
              this.error = true
            }
            if (data.response.status === 400) {
              this.formErrors = data.response.data
              this.$validate()
            }
          }).finally(() => {
            this.progress = false
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/auth/AccountRunnerAdminConfirmEmail.vue